<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">

                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>Filtrar Producto(s)</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-card flat>
                        <v-card-text>
                          <template>
                            <v-form ref="searchProduct" v-model="valid">
                              <v-container>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="8"
                                  >
                                    <v-dialog
                                      ref="dialog"
                                      v-model="modal"
                                      :return-value.sync="date"
                                      persistent
                                      width="290px"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                          v-model="dateRangeText"
                                          label="Rango Fechas de Creación"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="dates"
                                        scrollable
                                        range
                                        locale="es"
                                        :max="date"
                                        selected-items-text="seleccionados"
                                      >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="modal = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="$refs.dialog.save(date)"
                                        >
                                          OK
                                        </v-btn>
                                      </v-date-picker>
                                    </v-dialog>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="2"
                                  >
                                    <v-btn
                                      color="primary"
                                      block
                                      depressed
                                      @click="getProducts()"
                                    >
                                      <v-icon dark>
                                        manage_search
                                      </v-icon>
                                    </v-btn>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="2"
                                  >
                                    <v-btn
                                      color="green"
                                      block
                                      depressed
                                      @click="domwloadExcel()"
                                    >
                                      <v-icon dark>
                                        file_download
                                      </v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </template>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>Registro de Productos</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-title>
                              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Ingresar texto a buscar"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                              :headers="headers"
                              :items="items"
                              :search="search"
                            >
                              <template v-slot:item.status="{ item }">
                                <v-chip
                                  :color="getColorOrTextStatus(item.status, 'color')"
                                  dark
                                >
                                  {{ getColorOrTextStatus(item.status, 'text')  }}
                                </v-chip>
                              </template>

                              <template v-slot:item.actions="{ item }">
                                <v-btn
                                  depressed
                                  color="primary"
                                  @click="showDetail(item)"
                                >
                                  <v-icon dark>
                                    mdi-pencil
                                  </v-icon>
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>

              <v-dialog
                v-model="dialog"
                lg
              >
                <v-card>
                  <v-card-title class="primary dark">
                    <template>
                      <v-tabs
                          v-model="tab"
                          background-color="primary"
                          dark
                      >
                        <v-tab href="#tab-1">Producto</v-tab>
                        <v-tab href="#tab-2" :disabled="product.id ? false : true">Colores</v-tab>
                        <v-tab href="#tab-3" :disabled="product.id ? false : true">Imágenes</v-tab>
                        <v-tab href="#tab-4" :disabled="product.id ? false : true">Tallas</v-tab>
                      </v-tabs>
                    </template>
                  </v-card-title>

                  <v-card-text>
                    <v-tabs-items v-model="tab">
                      <v-tab-item
                        key="1"
                        value="tab-1"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="form" v-model="valid">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product.category_id"
                                        :items="select.categories"
                                        item-value="id"
                                        item-text="name"
                                        label="Categoria"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product.brand_id"
                                        :items="select.brands"
                                        item-value="id"
                                        item-text="name"
                                        label="Marca"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product.group"
                                        :items="select.groups"
                                        item-value="id"
                                        item-text="name"
                                        label="Group"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="product.name"
                                        label="Nombre del Producto"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="product.regular_price"
                                        label="Precio de Venta"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="product.off"
                                        label="Descuento (%)"
                                        outlined
                                        dense
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="product.sale_price"
                                        label="Precio con Descuento"
                                        outlined
                                        dense
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product.size_delivery"
                                        :items="select.size_deliveries"
                                        item-value="id"
                                        item-text="name"
                                        label="Tamaño del Producto"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="8"
                                    >
                                      <v-textarea
                                        v-model="product.description"
                                        outlined
                                        name="input-7-4"
                                        label="Descripcion"
                                        rows="3"
                                      ></v-textarea>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!valid"
                                        color="primary"
                                        block
                                        depressed
                                        @click="submitProduct()"
                                      >
                                        {{ product.id ? 'Actualizar' : 'Registrar' }}
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item
                        key="2"
                        value="tab-2"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColor" v-model="validProductColor">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product_color.color_id"
                                        :items="select.colors"
                                        item-value="id"
                                        item-text="name"
                                        label="Color"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product_color.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColor"
                                        color="primary"
                                        block
                                        depressed
                                        @click="submitProductColor()"
                                      >
                                        {{ product_color.id ? 'Actualizar' : 'Registrar' }}
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>
                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="PCHeaders"
                                    :items="PCItems"
                                  >
                                    <template v-slot:item.status="{ item }">
                                      <v-chip
                                        :color="getColorOrTextStatus(item.status, 'color')"
                                        dark
                                      >
                                        {{ getColorOrTextStatus(item.status, 'text')  }}
                                      </v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                      <v-btn
                                        depressed
                                        color="primary"
                                        @click="showDetailProductColor(item)"
                                      >
                                        <v-icon dark>
                                          mdi-pencil
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item
                        key="3"
                        value="tab-3"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColorImage" v-model="validProductColorImage">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product_color_image.product_color_id"
                                        :items="PCItems"
                                        item-value="id"
                                        item-text="color.name"
                                        label="Color"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product_color_image.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColorImage || imagesTmp.length == 0"
                                        color="primary"
                                        block
                                        depressed
                                        @click="saveProductColorImages()"
                                      >
                                        Registrar
                                      </v-btn>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="12"
                                    >
                                      <v-file-input
                                        v-model="imagesTmp"
                                        counter
                                        label="Seleccionar Imágenes"
                                        multiple
                                        :show-size="1000"
                                        :rules="[rules.required]"
                                        @change="imagesSelected"
                                        dense
                                        outlined
                                      >
                                        <template v-slot:selection="{ index, text }">
                                          <v-chip
                                            color="deep-purple accent-4"
                                            dark
                                            label
                                            small
                                          >
                                            {{ text }}
                                          </v-chip>
                                        </template>
                                      </v-file-input>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>

                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12">
                                  <v-expansion-panels popout v-model="active">
                                    <v-expansion-panel
                                      v-for="(pcii, i) in PCIItems"
                                      :key="i"
                                      hide-actions
                                    >
                                      <v-expansion-panel-header>
                                        <v-row
                                          align="center"
                                          class="spacer"
                                          no-gutters
                                        >
                                          <v-col
                                            cols="4"
                                            sm="2"
                                            md="1"
                                          >
                                            <v-avatar
                                              size="36px"
                                            >
                                              <v-icon
                                                :style="{'background-color':pcii.color.hexcolor}"
                                                text="circle"
                                              ></v-icon>
                                            </v-avatar>
                                          </v-col>

                                          <v-col
                                            class="hidden-xs-only"
                                            sm="5"
                                            md="3"
                                          >
                                            <strong>{{ pcii.color.name }}</strong>
                                            <span
                                              v-if="pcii.product_color_image"
                                              class="grey--text"
                                            >
                                              &nbsp;({{ pcii.product_color_image.length }})
                                            </span>
                                          </v-col>

                                          <v-col
                                            class="text-no-wrap"
                                            cols="5"
                                            sm="3"
                                          >
                                            <v-chip
                                              :color="getColorOrTextStatus(pcii.status, 'color')"
                                              class="ml-0 mr-2 black--text"
                                              label
                                              small
                                            >
                                              {{ getColorOrTextStatus(pcii.status, 'text') }}
                                            </v-chip>
                                          </v-col>

                                          <v-col
                                            class="grey--text text-truncate hidden-sm-and-down"
                                          >
                                            &mdash;
                                            Hacer clic para ver detalle de imágenes
                                          </v-col>

                                        </v-row>
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <v-divider></v-divider>
                                        <v-container>
                                          <template v-for="color in imagesRefactor">
                                            <draggable v-model="color.images" class="row" @change="color.update_position = true">
                                              <template v-if="pcii.color_id == color.color_id">
                                                <template v-for="(img, index) in color.images">
                                                  <v-col cols="12" md="3" sm="6" :key="img.id" class=".image">
                                                    <v-card class="mt-2 mb-2 image" color="grey lighten-4" flat>
                                                      <v-toolbar flat dense color="transparent">
                                                        <v-chip
                                                          color="red"
                                                          class="ml-0 mr-2 white--text"
                                                          label
                                                          small
                                                        >
                                                          <b># {{ index + 1 }}</b>
                                                        </v-chip>
                                                      </v-toolbar>
                                                     <v-img :src="img.image" height="50%">
                                                       <template v-slot:placeholder>
                                                        <v-row
                                                          class="fill-height ma-0"
                                                          align="center"
                                                          justify="center"
                                                        >
                                                          <v-progress-circular
                                                            indeterminate
                                                            color="grey lighten-5"
                                                          ></v-progress-circular>
                                                        </v-row>
                                                      </template>
                                                     </v-img>
                                                    </v-card>
                                                  </v-col>
                                                </template>
                                              </template>
                                            </draggable>
                                            <v-card-actions v-if="pcii.color_id == color.color_id">
                                              <v-btn
                                                :disabled="!color.update_position"
                                                color="primary"
                                                block
                                                depressed
                                                class="mt-n2"
                                                @click="updateOrderImg(color)"
                                              >
                                                Actualizar Orden
                                              </v-btn>
                                            </v-card-actions>
                                          </template>
                                        </v-container>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item
                        key="4"
                        value="tab-4"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColorSize" v-model="validProductColorSize">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product_color_size.product_color_id"
                                        :items="PCItems"
                                        item-value="id"
                                        item-text="color.name"
                                        label="Color"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product_color_size.size_id"
                                        :items="select.sizes"
                                        item-value="id"
                                        item-text="name"
                                        label="Talla"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="product_color_size.stock"
                                        label="Stock"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="product_color_size.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColorSize"
                                        color="primary"
                                        block
                                        depressed
                                        @click="submitProductColorSize()"
                                      >
                                        {{ product_color_size.id ? 'Actualizar' : 'Registrar' }}
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>
                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="PCSHeaders"
                                    :items="PCSItems"
                                  >
                                    <template v-slot:item.status="{ item }">
                                      <v-chip
                                        :color="getColorOrTextStatus(item.status, 'color')"
                                        dark
                                      >
                                        {{ getColorOrTextStatus(item.status, 'text')  }}
                                      </v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                      <v-btn
                                        depressed
                                        color="primary"
                                        @click="showDetailProductColorSize(item)"
                                      >
                                        <v-icon dark>
                                          mdi-pencil
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="adm_orange"
                      text
                      @click="dialog = false"
                    >
                      Cerrar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </v-row>
          </template>

          <div
            style="
              position: fixed;
              bottom: 16px;
              right: 16px;
              display: flex;
              flex-direction: column;
              gap: 12px;
              z-index: 9999;
            "
          >
            <v-btn
              fab
              bottom
              color="primary"
              dark
              @click="dialog = true"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  bottom
                  color="green"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="domwloadExcel()"
                >
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Descargar Stock</span>
            </v-tooltip>
          </div>
        </div>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import draggable from 'vuedraggable'
  import firebase from 'firebase'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'ProductView',
    components: {
      DefaultLayout,
      draggable
    },
    data () {
      return {
        overlay: false,
        dialog: false,
        tab: null,
        panel: [1],
        active: null,
        modal: false,
        dates: [moment().toISOString().substr(0, 10), moment().toISOString().substr(0, 10)],
        date: moment().toISOString().substr(0, 10),
        searchProduct: {
          startDate: null,
          endDate: null
        },
        search: '',
        headers: [
          { text: 'MARCA', value: 'brand.name'},
          { text: 'GRUPO', value: 'group' },
          { text: 'PRODUCTO', value: 'name' },
          { text: 'P. VENTA', value: 'regular_price' },
          { text: 'DESCUENTO (%)', value: 'off' },
          { text: 'P. C/ DESCUENTO', value: 'sale_price' },
          { text: 'TAMAÑO', value: 'size_delivery' },
          { text: 'ESTADO', value: 'status' },
          { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }
        ],
        items: [],
        valid: true,
        validProductColor: true,
        validProductColorImage: true,
        validProductColorSize: true,
        rules: {
          required: v => !!v || 'Por favor completar este campo'
        },
        select: {
          categories: [],
          brands: [],
          colors: [],
          sizes: [],
          groups: [
            { id: 'HOT WHEELS', name: 'HOT WHEELS' },
            { id: 'JURASSIC WORLD', name: 'JURASSIC WORLD' },
            { id: 'MINECRAFT', name: 'MINECRAFT' },
            { id: 'JUEGOS DE MESA', name: 'JUEGOS DE MESA' },
            { id: 'THOMAS & FRIENDS', name: 'THOMAS & FRIENDS' },
            { id: 'ANGRY BIRDS', name: 'ANGRY BIRDS' },
            { id: 'CHOMP SQUAD', name: 'CHOMP SQUAD' },
            { id: 'BLAZE', name: 'BLAZE' },
            { id: 'SMASHERS', name: 'SMASHERS' },
            { id: 'MUÑECAS', name: 'MUÑECAS' },
            { id: 'NINTENDO SWITCH', name: 'NINTENDO SWITCH' },
            { id: 'NERF', name: 'NERF' },
            { id: 'PLAY DOH', name: 'PLAY DOH' },
            { id: 'SUPER MARIO', name: 'SUPER MARIO' },
            { id: 'PRINCESAS', name: 'PRINCESAS' },
            { id: 'FRIEND', name: 'FRIEND' },
            { id: 'MUNDO BEBE', name: 'MUNDO BEBE' },
            { id: 'DIDACTICOS', name: 'DIDACTICOS' },
            { id: 'MOCHILAS, CARTUCHERAS Y LONCHERAS', name: 'MOCHILAS, CARTUCHERAS Y LONCHERAS' },
            { id: 'ÚTILES', name: 'ÚTILES' },
            { id: 'PELUCHES INTERACTIVOS', name: 'PELUCHES INTERACTIVOS' },
            { id: 'MAQUILLAJE', name: 'MAQUILLAJE' },
            { id: 'ELECTROHOGAR', name: 'ELECTROHOGAR' },
            { id: 'NAVIDAD', name: 'NAVIDAD' },
            { id: 'BLUEY', name: 'BLUEY' }
          ],
          size_deliveries: [
            { id: 1, name: 'PEQUEÑO' },
            { id: 2, name: 'MEDIANO' },
            { id: 3, name: 'GRANDE' }
          ],
          status: [
            { id: 1, name: 'ACTIVO' },
            { id: 2, name: 'INACTIVO' }
          ]
        },
        product: {
          id: null,
          brand_id: null,
          category_id: null,
          name: null,
          description: null,
          average_star: null,
          off: null,
          regular_price: null,
          sale_price: null,
          size_delivery: null,
          group: null,
          status: null
        },
        PCHeaders: [
          { text: 'COLOR', value: 'color.name', width: '60%' },
          { text: 'ESTADO', value: 'status', width: '20%' },
          { text: 'ACCIONES', value: 'actions', width: '20%', filterable: false, sortable: false }
        ],
        PCItems: [],
        product_color: {
          id: null,
          product_id: null,
          color_id: null,
          status: null
        },
        PCIItems: [],
        imagesRefactor: [],
        product_color_image: {
          id: null,
          product_color_id: null,
          images: [],
          status: null
        },
        imagesTmp: [],
        PCSHeaders: [
          { text: 'COLOR', value: 'product_color.color.name', width: '20%' },
          { text: 'TALLA', value: 'size.name', width: '20%' },
          { text: 'STOCK', value: 'stock', width: '20%' },
          { text: 'ESTADO', value: 'status', width: '20%' },
          { text: 'ACCIONES', value: 'actions', width: '20%', filterable: false, sortable: false }
        ],
        PCSItems: [],
        product_color_size: {
          id: null,
          product_color_id: null,
          size_id: null,
          stock: null,
          status: null
        },
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    computed: {
      dateRangeText () {
        let newDate = [];
        newDate[0] = this.formatDate(this.dates[0]);
        newDate[1] = this.formatDate(this.dates[1]);

        if (newDate[1]) {
          if (this.dates[1] < this.dates[0]) {
            let newStartDateOld = newDate[1];
            let newEndDateOld = newDate[0];
            newDate[0] = newStartDateOld;
            newDate[1] = newEndDateOld;
          }
        }

        if (newDate[0] && !newDate[1]) {
          newDate[1] = newDate[0];
        }

        const [day, month, year] = newDate[0].split('/');
        const start = `${year}-${month}-${day}`;

        const [day2, month2, year2] = newDate[1].split('/');
        const end = `${year2}-${month2}-${day2}`;

        this.searchProduct.startDate = start;
        this.searchProduct.endDate = end;

        if (end) {
          if (end < start) {
            this.searchProduct.startDate = end;
            this.searchProduct.endDate = start;
          }
        }

        return newDate.join(' - ');
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      getProducts() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_PRODUCTS, {
          params: {
            startDate: this.searchProduct.startDate,
            endDate: this.searchProduct.endDate
          }
        })
        .then(response => {
          this.items = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      domwloadExcel() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.DOMWLOAD_PRODUCTS, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'text/csv'
          },
          params: {
            startDate: this.searchProduct.startDate,
            endDate: this.searchProduct.endDate
          }
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getCategories() {
        axios.get(process.env.DINO.PATH.GET_CATEGORIES)
        .then(response => {
          this.select.categories = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        });
      },

      getBrands() {
        axios.get(process.env.DINO.PATH.GET_BRANDS)
        .then(response => {
          this.select.brands = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        });
      },

      getColors() {
        axios.get(process.env.DINO.PATH.GET_COLORS)
        .then(response => {
          this.select.colors = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        });
      },

      getSizes() {
        axios.get(process.env.DINO.PATH.GET_SIZES)
        .then(response => {
          this.select.sizes = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        });
      },

      getColorOrTextStatus(status, type) {
        let value = '';

        if (type === 'color') {
          value = status == 1 ? 'green' : 'red';
        } else if (type === 'text') {
          value = status == 1 ? 'ACTIVO' : 'INACTIVO';
        }

        return value;
      },

      cleanForm() {
        this.product.id = null;
        this.product.average_star = null;
        this.product.description = null;
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      },

      cleanFormProductColor() {
        this.product_color.id = null;
        this.product_color.color_id = null;
        this.product_color.status = null;
        if (!this.dialog) {
          this.product_color.product_id = null;
          this.PCItems = [];
          // this.$refs.formProductColor.reset();
          // this.$refs.formProductColor.resetValidation();
        }
      },

      cleanFormProductColorImage() {
        this.product_color_image.id = null;
        this.product_color_image.status = null;
        this.product_color_image.product_color_id = null;
        this.imagesTmp = [];
        if (!this.dialog) {
          this.product_color_image.images = [];
          this.imagesRefactor = [];
          this.PCIItems = [];
          // this.$refs.formProductColorImage.reset();
          // this.$refs.formProductColorImage.resetValidation();
        }
      },

      cleanFormProductColorSize() {
        this.product_color_size.id = null;
        this.product_color_size.product_color_id = null;
        this.product_color_size.size_id = null;
        this.product_color_size.stock = null;
        this.product_color_size.status = null;
        if (!this.dialog) {
          this.product_color.product_id = null;
          this.PCSItems = [];
          // this.$refs.formProductColorSize.reset();
          // this.$refs.formProductColorSize.resetValidation();
        }
      },

      showDetail(item) {
        this.product.id = item.id;
        this.product.brand_id = item.brand.id;
        this.product.category_id = item.category_id;
        this.product.name = item.name;
        this.product.description = item.description;
        this.product.average_star = item.average_star;
        this.product.off = item.off;
        this.product.regular_price = item.regular_price;
        this.product.sale_price = item.sale_price;
        this.product.size_delivery = item.size_delivery;
        this.product.group = item.group;
        this.product.status = item.status;
        this.product_color.product_id = item.id;

        this.dialog = true;
        this.getProductColors();
        this.getProductColorImages();
        this.getProductColorSizes();
      },

      submitProduct() {
        this.overlay = true;
        axios.put(process.env.DINO.PATH.PRODUCT_SAVE_PUT, this.product)
        .then(response => {
          this.product.id = response.data.product_id;
          this.product_color.product_id = response.data.product_id;
          this.getProducts();
          this.showMessage(response.data.message, 'green');
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getProductColors() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLORS.replace(':product_id', this.product.id))
        .then(response => {
          this.PCItems = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      showDetailProductColor(item) {
        this.product_color.id = item.id;
        this.product_color.color_id = item.color_id;
        this.product_color.product_id = item.product_id;
        this.product_color.status = item.status;
      },

      submitProductColor() {
        this.overlay = true;
        axios.put(process.env.DINO.PATH.SAVE_PRODUCT_COLOR, this.product_color)
        .then(response => {
          this.$refs.formProductColor.reset();
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.cleanFormProductColor();
          this.getProductColors();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getProductColorImages() {
        this.overlay = true;
        const storage = firebase.storage()
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLOR_IMAGES.replace(':product_id', this.product.id))
        .then(response => {
          this.PCIItems = response.data;
        })
        .then(() => {
          let imagesRefactor = [];
          this.PCIItems.map((pcii) => {

            let images = [];
            pcii.product_color_image.map((image) => {
              images.push({ id: image.id, product_color_id: image.product_color_id, image: image.image, order: image.order });
            });

            imagesRefactor.push({
              color_id: pcii.color_id,
              update_position: false,
              status: pcii.status,
              images: images
            });

          });

          this.imagesRefactor = imagesRefactor;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      saveProductColorImages() {
        this.overlay = true;

        const form = new FormData();
        this.imagesTmp.forEach((file, index) => {
            form.append('files', file, file.name);
        });

        form.append('id', this.product_color_image.id);
        form.append('product_color_id', this.product_color_image.product_color_id);
        form.append('images', JSON.stringify(this.product_color_image.images));
        form.append('status', this.product_color_image.status);

        const config = {
          headers: { 'Content-Type': 'multipart/form-data' }
        }

        axios.post(process.env.DINO.PATH.SAVE_PRODUCT_COLOR_IMAGES, form, config)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.onUpload();
        })
        .then(() => {
          this.$refs.formProductColorImage.reset();
          this.cleanFormProductColorImage();
          this.getProductColorImages();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      onUpload() {
        /*
        * Upload images to Firebease Storage is for type 'grande'
        * the images type 'chico' is upload in backend
        */
        const storage = firebase.storage();
        const metadata = {
          cacheControl: "public, max-age=31536000"
        };

        this.imagesTmp.map((file, index) => {
          let task = storage.ref(`/img/products/872x872/${file.name}`).put(file, metadata);
        });
      },

      imagesSelected() {
        const domain = 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img';
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

        if (!this.imagesTmp || !this.imagesTmp.length) return;

        const promises = this.imagesTmp.map(file => {
          return new Promise((resolve, reject) => {
            // Validar tipo
            if (!allowedTypes.includes(file.type)) {
              this.showMessage(`Tipo de imagen inválido, solo se acepta JPEG, JPG o PNG: ${file.name}`, 'deep-purple accent-4');
              console.log(`Tipo de imagen inválido: ${file.name}`);
              reject(new Error(`Tipo inválido: ${file.name}`));
              return;
            }

            const reader = new FileReader();
            reader.onload = e => {
              const imgEl = new Image();
              imgEl.onload = () => {
                // Validar dimensiones
                if (imgEl.width !== 872 || imgEl.height !== 872) {
                  this.showMessage(`Dimensiones inválidas, solo se acepta 872x872: ${file.name} (${imgEl.width}x${imgEl.height})`, 'deep-purple accent-4');
                  console.log(`Dimensiones inválidas: ${file.name} (${imgEl.width}x${imgEl.height})`);
                  reject(new Error(`Dimensiones inválidas: ${file.name}`));
                } else {
                  resolve(file);
                }
              };
              imgEl.src = e.target.result;
            };
            reader.readAsDataURL(file);
          });
        });

        // Ejecutar todas las validaciones
        Promise.all(promises)
          .then(validFiles => {
            // Todas las imágenes son válidas, generamos URLs
            const img = [];

            validFiles.forEach((file, index) => {
              const order = index + 1;

              // GRANDE
              let image = encodeURIComponent(`/products/872x872/${file.name}`);
              img.push({
                image: domain.concat(`${image}?alt=media`),
                order,
                type: 'grande',
                name: file.name
              });

              // MEDIANO (solo la primera imagen)
              if (index === 0) {
                image = encodeURIComponent(`/products/300x300/${file.name}`);
                img.push({
                  image: domain.concat(`${image}?alt=media`),
                  order,
                  type: 'mediano',
                  name: file.name
                });
              }

              // CHICO
              image = encodeURIComponent(`/products/100x100/${file.name}`);
              img.push({
                image: domain.concat(`${image}?alt=media`),
                order,
                type: 'chico',
                name: file.name
              });
            });

            // Guardamos solo imágenes válidas
            this.imagesTmp = validFiles;
            this.product_color_image.images = img;
          })
          .catch(err => {
            // Al menos una imagen falló → cancelar toda la selección
            this.imagesTmp = [];
            this.product_color_image.images = [];
          });
      },

      imagesSelectedOld () {
        const domain = 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img';
        let img = [];
        this.imagesTmp.map((file, index) => {
          let order = index + 1;

          let image = encodeURIComponent(`/products/872x872/${file.name}`);
          image = domain.concat(`${image}?alt=media`);
          img.push({ image: image, order: order, type: 'grande', name: file.name});

          if (index == 0) {
            image = encodeURIComponent(`/products/300x300/${file.name}`);
            image = domain.concat(`${image}?alt=media`);
            img.push({ image: image, order: order, type: 'mediano', name: file.name});
          }

          image = encodeURIComponent(`/products/100x100/${file.name}`);
          image = domain.concat(`${image}?alt=media`);
          img.push({ image: image, order: order, type: 'chico', name: file.name});
        });

        this.product_color_image.images = img;
      },

      updateOrderImg(color) {
        this.overlay = true;

        let img = [];
        color.images.map((image, index) => {
          let order = index + 1;
          img.push({ product_color_id: image.product_color_id, image: image.image, order: order, type: 'grande', status: color.status });
          if (index == 0) {
            img.push({ product_color_id: image.product_color_id, image: image.image.replace('872x872', '300x300'), order: order, type: 'mediano', status: color.status });
          }
          img.push({ product_color_id: image.product_color_id, image: image.image.replace('872x872', '100x100'), order: order, type: 'chico', status: color.status });
        });

        axios.put(process.env.DINO.PATH.SAVE_ORDER_PRODUCT_COLOR_IMAGES, img)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.cleanFormProductColorImage();
          this.getProductColorImages();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getProductColorSizes() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLOR_SIZES.replace(':product_id', this.product.id))
        .then(response => {
          this.PCSItems = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      showDetailProductColorSize(item) {
        this.product_color_size.id = item.id;
        this.product_color_size.product_color_id = item.product_color_id;
        this.product_color_size.size_id = item.size_id;
        this.product_color_size.stock = item.stock;
        this.product_color_size.status = item.status;
      },

      submitProductColorSize() {
        let color = '';
        for (let i = 0; i < this.PCItems.length; i++) {
          if (this.PCItems[i].id == this.product_color_size.product_color_id) {
            color = this.PCItems[i].color.name;
            break;
          }
        }

        if (color == 'NOT_COLOR') {
          let size = '';
          for (let j = 0; j < this.select.sizes.length; j++) {
            if (this.select.sizes[j].id == this.product_color_size.size_id) {
              size = this.select.sizes[j].name;
              break;
            }
          }

          if (size != 'NOT_SIZE') {
            this.showMessage('La talla permitida para un color NOT_COLOR es el NOT_SIZE, caso contrario registrar otro color', 'red');
            return;
          }
        }

        this.overlay = true;
        axios.put(process.env.DINO.PATH.SAVE_PRODUCT_COLOR_SIZE, this.product_color_size)
        .then(response => {
          this.$refs.formProductColorSize.reset();
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.cleanFormProductColorSize();
          this.getProductColorSizes();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      domwloadExcel() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.DOMWLOAD_STOCK_PRODUCT, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'text/xls'
          }
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      }

    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getProducts();
      this.getCategories();
      this.getBrands();
      this.getColors();
      this.getSizes();
    },
    watch: {
      dialog (val) {
        if (val === false) {
          this.cleanFormProductColorSize();
          this.cleanFormProductColorImage();
          this.cleanFormProductColor();
          this.cleanForm();
          this.active = null;
          this.tab = 'tab-1';
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/manage/Product.vue